<template>
    <div v-if="(initialSeconds>0||receive_award)&&page_init">
        <div class="floating-ball"
             :style="{ top: position.top + 'px', left: position.left + 'px' }"
             @mousedown="startDrag" @touchstart="startDrag"
             @mouseup="stopDrag" @touchend="stopDrag"
             @mousemove="handleDrag" @touchmove="handleDrag"
             @click="handleClick">
            <!-- 悬浮球的内容 -->
            <span>{{ receive_award?'Receive':displayTime }}</span>
        </div>
        <mt-popup class="popup-con" v-model="popupVisible" :overlay="false">
            <div v-if="receive_award">
                <div class="r-receive-alert">
                    <div class="r-tip-title">Rec. Comp.</div>
                    <div class="r-tip-content">Congrats on ₱{{amount}}</div>
                    <div class="r-prize-btn">
                        <Button class="r-prize-receive-btn" type="primary" size="small" @click="returnAward(id)">
                            Receive Now
                        </Button>
                    </div>
                </div>
            </div>
            <div v-else class="alert-tip">
                <div class="new-p-award">NWF</div>
                <div class="recharge-btn">{{ displayTime }}</div>
                <!--再次充值可以领取金额的50%,充值越多奖励越多！！！-->
                <div class="new-p-content">If you recharge again, you can receive <b class="gift_prop">{{gift_prop}}%</b> of the amount. <br>The more you recharge, the greater the rewards! ! !</div>
                <div class="tup">
                    <Button class="tup-btn" type="primary" size="small" @click="toRecharge">
                        Top-Up Now
                    </Button>
                </div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
    import {Button, Popup} from 'mint-ui';
    import 'mint-ui/lib/style.css';
    import {getRechargeGiftInfo, refundNewGift} from "../api/order";
    import {DebounceBy} from "../api/user"

    export default {
        name: "NewRechargeBonus",
        props: {
            trigger: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Button,
            'mt-popup': Popup
        },
        data() {
            return {
                showSwitch: true,
                page_init: false,
                receive_award: false,
                isDragging: false,
                popupVisible: true,
                startPosition: {x: 0, y: 0},
                position: {top: 100, left: 100},
                timer: null,
                gift_prop: 0,
                amount: 0,
                id: '',
                initialSeconds: 0,
                timeRemaining: {
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                }
            };
        },
        computed: {
            displayTime() {
                return `${this.padZero(this.timeRemaining.hours)}:${this.padZero(
                    this.timeRemaining.minutes
                )}:${this.padZero(this.timeRemaining.seconds)}`;
            }
        },
        mounted() {
            this.getRechargeTrigger()
            this.updateTime();
            // 每秒更新一次倒计时
            this.timer = setInterval(() => {
                this.updateTime();
            }, 1000);
        },
        beforeDestroy() {
            // 在组件销毁前清除定时器
            clearInterval(this.timer);
        },
        methods: {
            getRechargeTrigger() {
                let that = this
                getRechargeGiftInfo().then(res => {
                    if (res.status === 200) {
                        if (res.data.flag_trigger === 2)
                            that.initialSeconds = res.data.countdown_time
                            that.gift_prop = res.data.gift_prop
                        if (res.data.flag_trigger === 3) {
                            that.amount = res.data.award_info.amount
                            that.id = res.data.award_info.id
                            that.receive_award = true
                        }
                        that.page_init = true
                    }
                }).catch((res) => {
                    this.$dialog.error(res.data.msg);
                })
            },
            returnAward: DebounceBy(function (id) {
                if (id === '')
                    return this.$dialog.error('Parameter error')
                let that = this
                refundNewGift({id: id}).then(res => {
                    if (res.status === 200) {
                        that.receive_award = false
                        that.page_init = false
                        this.$dialog.toast({mes: res.msg})
                    }
                }).catch((res) => {
                    this.$dialog.error(res.data.msg);
                })
            }, 3000),
            openContainer() {
                this.getRechargeTrigger()
                this.popupVisible = !this.popupVisible;
            },
            toRecharge() {
                this.openContainer()
                this.$router.push({path: "/user/Recharge_cash"})
            },
            updateTime() {
                if (this.initialSeconds > 0) {
                    this.initialSeconds--;
                    this.timeRemaining.hours = Math.floor(this.initialSeconds / 3600);
                    this.timeRemaining.minutes = Math.floor(
                        (this.initialSeconds % 3600) / 60
                    );
                    this.timeRemaining.seconds = this.initialSeconds % 60;
                } else {
                    // 倒计时结束的处理
                    clearInterval(this.timer);
                }
            },
            padZero(value) {
                return value < 10 ? `0${value}` : value;
            },
            startDrag(event) {
                const touch = event.type === 'touchstart' ? event.touches[0] : event;
                this.isDragging = true;
                this.startPosition = {
                    x: touch.clientX - this.position.left,
                    y: touch.clientY - this.position.top
                };
            },
            handleDrag(event) {
                if (this.isDragging) {
                    const touch = event.type === 'touchmove' ? event.touches[0] : event;
                    this.position = {
                        top: touch.clientY - this.startPosition.y,
                        left: touch.clientX - this.startPosition.x
                    };
                }
            },
            stopDrag() {
                this.isDragging = false;
            },
            handleClick() {
                if (!this.isDragging) {
                    // 点击事件处理逻辑
                    this.openContainer();
                }
            }
        }
    };
</script>

<style scoped>
    .floating-ball {
        position: fixed;
        cursor: move;
        width: 130px;
        height: 130px;
        background-image: url("../assets/images/l-ball.gif");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .floating-ball span {
        font-weight: bold;
        margin-top: 65px;
        font-size: .3em;
        color: orangered;
    }

    .popup-con {
        background: none;
    }

    .alert-tip {
        width: 280px;
        height: 280px;
        /*background-image: url("../assets/images/demo.gif");*/
        background-image: url("../assets/images/clock.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .new-p-award{
        color: goldenrod;
        font-size: .35rem;
        font-weight: bold;
        margin-top: 80px;
    }
    .recharge-btn {
        padding: 10px;
        color: red;
        font-size: .4rem;
        font-weight: bold;
        text-shadow: 0 0 10px red, 0 0 20px red, 0 0 30px red;
    }
    .new-p-content{
        overflow-wrap: break-word;
        width: 68%;
        font-size: .2rem;
        line-height: .25rem;
        text-align: center;
        color: #00c3f9;
    }

    .tup{
        margin-top: 80px;
    }
    .tup-btn{
        background-color: gold;
    }

    .r-receive-alert {
        width: 230px;
        height: 230px;
        background-image: url("../assets/images/red-packets.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .r-tip-title {
        color: red;
        font-weight: bold;
        font-size: .35rem;
        margin-top: 40px;
    }

    .r-tip-content {
        color: goldenrod;
        font-size: .3rem;
        margin-top: 10px;
    }

    .r-prize-btn {
        margin-top: 70px;
    }

    .r-prize-receive-btn {
        background-color: gold;
    }
    .gift_prop{
        color: orangered;
    }
</style>
